'use client'

export default function CookieSettingsButton({ className = '' }: { className?: string }) {
  return (
    <button
      type="button"
      className={`transition hover:text-white ${className}`}
      onClick={() => window.dispatchEvent(new Event('allisports:manage-consent'))}
    >
      Cookie settings
    </button>
  )
}
